import { useQuery } from "@tanstack/react-query";
import { getUsers } from "services/users.service";

export const useUsers = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "users",
    params.page,
    params.size,
    params.search,
    params.corporate,
    params.isActive,
    params.businessType,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getUsers(params),
    enabled,
    ...options,
  });
};
